import { render, staticRenderFns } from "./ComOffer.vue?vue&type=template&id=f0202064&scoped=true&"
import script from "./ComOffer.vue?vue&type=script&lang=js&"
export * from "./ComOffer.vue?vue&type=script&lang=js&"
import style0 from "./ComOffer.vue?vue&type=style&index=0&id=f0202064&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0202064",
  null
  
)

export default component.exports